/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Generic Error
 * Generic Error Model Structure
 */
export interface GenericErrorModel {
  /** Error message */
  message?: string
  errors?: {
    details?: string[]
  }
}

/**
 * Account Verification Error
 * Account Verification Error Structure. Account has not been verified through email
 */
export interface AccountVerifiedError {
  /** @example "Account not verified" */
  error?: string
  /** @example "Please verify your email to access your account." */
  message?: string
  data?: {
    /** @example "https://example.com/resend-verification" */
    resend_verification_link?: string
  }
}

/**
 * Form Item Error
 * Form Item Error Structure
 */
export interface FormItemError {
  /** Index of the field within the form */
  item?: number
  /** The attribute the error belongs to */
  attribute?: string
  /** The error message associated with the  */
  message?: string
}

/**
 * Forgot Password Request
 * Initial Request to reset account password
 */
export interface ForgotPasswordRequest {
  /**
   * @format email
   * @example "user@example.com"
   */
  email: string
}

/**
 * Forgot Password Request
 * Initial Request to reset account password
 */
export interface ResetPasswordRequest {
  /**
   * @format token
   * @example "reset_token_here"
   */
  token: string
  /**
   * @format email
   * @example "user@example.com"
   */
  email: string
  /**
   * @format password
   * @example "newSecurePassword123"
   */
  password: string
  /**
   * @format password
   * @example "newSecurePassword123"
   */
  password_confirmation: string
}

/**
 * Authorization
 * Authorization Structure
 */
export interface AuthStruct {
  /** @example "new_access_token_here" */
  access_token?: string
  /** @example "refresh_token_here" */
  refresh_token?: string
  /** @example "bearer" */
  token_type?: string
  /** @example 3600 */
  expires_in?: number
  /** @example 1705097237 */
  expiry_ts?: number | null
}

/**
 * Create User Request
 * Request body to register a new user
 */
export interface CreateUserRequest {
  /** First Name and Last Name */
  name?: string
  /**
   * @format email
   * @example "account@example.com"
   */
  email?: string
  /**
   * @format password
   * @example "password123"
   */
  password?: string
}

/**
 * Account Login
 * Account Login Object
 */
export interface LoginAccount {
  /**
   * @format email
   * @example "account@example.com"
   */
  email: string
  /**
   * @format password
   * @example "password123"
   */
  password: string
}

/**
 * Store Game Request
 * Request body to store a Game model
 */
export interface StoreGameRequest {
  /** Unique identifier for the parent Week */
  week_id: number
}

/**
 * Store Host Request
 * Request body to store a host model
 */
export interface StoreHostRequest {
  /** Unique identifier for the parent User */
  owner_id: number
  /** Name of the host */
  name: string
  /** Slug of name */
  code: string
  /** day of week for game */
  game_day: string
  /** Id of the active season */
  active_season_id: number | null
  /**
   * the buyin amount per week
   * @format float
   * @example "20.00"
   */
  buyin_default: number
  /** description */
  description: string
}

/**
 * Store Season Request
 * Request body to store a Season model
 */
export interface StoreSeasonRequest {
  /** Unique identifier for the parent Host */
  host_id: number
  /** Name of the season */
  name: string
  /**
   * Start date of the game, must be a unique date for the season associated with the host_id
   * @format date
   */
  start_date: string
  /**
   * End date of the game, optional, must be a date after or equal to start_date if provided
   * @format date
   */
  end_date?: string
  /**
   * Date of the tournament, optional, must be a date before or equal to end_date if provided
   * @format date
   */
  tournament_date?: string
}

/**
 * Patch Season Request
 * Request body to store a Season model
 */
export interface PatchSeasonRequest {
  /** Unique identifier for the parent Host */
  host_id: number
  /** Name of the season */
  name: string
  /**
   * Start date of the game, must be a unique date for the season associated with the host_id
   * @format date
   */
  start_date: string
  /**
   * End date of the game, optional, must be a date after or equal to start_date if provided
   * @format date
   */
  end_date?: string
  /**
   * Date of the tournament, optional, must be a date before or equal to end_date if provided
   * @format date
   */
  tournament_date?: string
}

/**
 * Store Week Request
 * Request body to store a Week model
 */
export interface StoreWeekRequest {
  /** Unique identifier for the parent Season */
  season_id?: number
  /**
   * Start date of the week, must be a unique date for the season weeks and start on a Monday
   * @format date
   */
  date?: string
  /** Flag to determine if week is a tournament */
  is_tournament?: number
}

/**
 * Game
 * Game model
 */
export interface Game {
  /**
   * Unique identifier for the Game
   * @default "0"
   */
  id?: number
  /**
   * Unique identifier for the parent Week
   * @default "0"
   */
  week?: number
  /**
   * game number for the week
   * @default "1"
   * @example 1
   */
  number?: number
  /**
   * flag for if player order and dealer are set
   * @default false
   */
  is_seated?: boolean
  /**
   * flag for if game is complete
   * @default false
   */
  is_completed?: boolean
  player_details?: GameUser[]
}

/**
 * GameUser
 * GameUser model
 */
export interface GameUser {
  /**
   * Unique identifier for the GameUser
   * @default "0"
   */
  id?: number
  /**
   * Unique identifier for the GameUser's userweek
   * @default "0"
   */
  userweek_id?: number
  /**
   * name of the player
   * @default ""
   */
  name?: string
  /**
   * the position from the dealer
   * @default "0"
   */
  startposition?: number
  /**
   * the finishing position of the player
   * @default "0"
   */
  endposition?: number
  /**
   * flag for if the player is the dealer
   * @default "false"
   */
  dealer?: boolean
  /**
   * the number of points earned in this game
   * @format float
   * @default "10.00"
   */
  points?: number
  /**
   * the number of dollars earned in this game
   * @format float
   * @default "10.00"
   */
  payout?: number
}

/**
 * Host
 * Host model
 */
export interface Host {
  /** Unique identifier for the Host */
  id: number
  /**
   * name of the host
   * @example "John Doe - Season 1"
   */
  name: string
  /**
   * the day games are played on
   * @example "Monday"
   */
  game_day: string
  /**
   * the buyin amount per week
   * @format float
   * @example "20.00"
   */
  buyin: number
  /**
   * user name of the host
   * @example "John Doe"
   */
  owner_name: string
  players: HostUser[]
  /** Season model */
  active_season: SeasonSummary
  seasons: {
    /** The ID of the season */
    value: number
    /** The name of the season */
    text: string
  }[]
}

/**
 * HostUser
 * HostUser model
 */
export interface HostUser {
  /** Unique identifier for the HostUser */
  id?: number
  /** Unique identifier for the User */
  user_id?: number
  /**
   * name of the user
   * @example "Jane Doe"
   */
  name?: string
  /** flag saying if player is an admin */
  is_admin?: boolean
  /** flag saying if player is active */
  is_active?: boolean
}

/**
 * Season
 * Season model
 */
export interface Season {
  /** Unique identifier for the Season */
  id: number
  /** Unique identifier for the Host */
  host_id: number
  /**
   * name of season
   * @example "Season 1"
   */
  name: string
  /**
   * date of start of season
   * @format date
   * @example "2024-01-01"
   */
  start_date: string
  /**
   * date of the end of season
   * @format date
   * @example "2024-02-05"
   */
  end_date: string
  /**
   * date of the season tournament
   * @format date
   * @example "2024-02-05"
   */
  tournament_date: string | null
  /** id of the season winner */
  winner_id: number | null
  /** Week model */
  active_week: Week
  weeks: {
    /** The ID of the week */
    value?: number
    /** The date of the season */
    text?: string
  }[]
  rankings: {
    /** id of user */
    user?: string
    /** Player name */
    name?: string
    /** Total monies paid to player this season */
    total_paid?: decimal
    /**
     * sum of the best '6' weeks of play
     * @format float
     */
    total_top_6_points?: number
    /** total first place finishes this season */
    count_firsts?: number
    /** total second place finishes this season */
    count_seconds?: number
    /** total third place finishes this season */
    count_thirds?: number
    /** points for best week of season */
    top_week_1_points?: {
      /** The ID of the week */
      week_id?: number
      /**
       * Points for the top week
       * @format float
       */
      points?: number
    }[]
    /** points for second best week of season */
    top_week_2_points?:
      | {
          /** The ID of the week */
          week_id?: number
          /**
           * Points for the top week
           * @format float
           */
          points?: number
        }[]
      | null
    /** points for third best week of season */
    top_week_3_points?:
      | {
          /** The ID of the week */
          week_id?: number
          /**
           * Points for the top week
           * @format float
           */
          points?: number
        }[]
      | null
    /** points for fourth best week of season */
    top_week_4_points?:
      | {
          /** The ID of the week */
          week_id?: number
          /**
           * Points for the top week
           * @format float
           */
          points?: number
        }[]
      | null
    /** points for fifth best week of season */
    top_week_5_points?:
      | {
          /** The ID of the week */
          week_id?: number
          /**
           * Points for the top week
           * @format float
           */
          points?: number
        }[]
      | null
    /** points for sixth best week of season */
    top_week_6_points?:
      | {
          /** The ID of the week */
          week_id?: number
          /**
           * Points for the top week
           * @format float
           */
          points?: number
        }[]
      | null
  }[]
}

/**
 * Season
 * Season model
 */
export interface SeasonSummary {
  /** Unique identifier for the Season */
  id?: number
  /** Unique identifier for the Host */
  host_id?: number
  /**
   * name of season
   * @example "Season 1"
   */
  name?: string
  /**
   * date of start of season
   * @format date
   * @example "2024-01-01"
   */
  start_date?: string
  /**
   * date of the end of season
   * @format date
   * @example "2024-02-05"
   */
  end_date?: string
  /**
   * date of the season tournament
   * @format date
   * @example "2024-02-05"
   */
  tournament_date?: string
  /** id of the season winner */
  winner_id?: number
  /** Week model */
  active_week?: Week
  weeks?: {
    /** The ID of the season */
    value: number
    /** The name of the season */
    text: string
  }[]
}

/**
 * User
 * User model
 */
export interface User {
  /** Unique identifier for the User */
  id: number
  /**
   * Name of the User
   * @example "John Doe"
   */
  name: string
  /**
   * Email address of the User
   * @format email
   * @example "user@example.com"
   */
  email: string
  profile: {
    hosts: Host[]
  }
}

/**
 * UserWeek
 * UserWeek model
 */
export interface UserWeek {
  /** Unique identifier for the UserWeek */
  id?: number
  /** Unique identifier for the HostUser */
  hostuser_id?: number
  /**
   * name of the player
   * @example "Jane Doe"
   */
  name?: string
  /**
   * The amount paid in Canadian Dollars (CAD) for this week
   * @format float
   * @example 12.45
   */
  paid_amount?: number
  /**
   * the number of points earned in this week
   * @format float
   * @example "5.23"
   */
  points?: number
  /**
   * the number of dollars earned in this week
   * @format float
   * @example "5.23"
   */
  payout?: number
}

/**
 * Week
 * Week model
 */
export interface Week {
  /** Unique identifier for the Week */
  id?: number
  /** name of the week */
  name?: string
  /** description of the week */
  description?: string
  /** Unique identifier for the parent Season */
  season_id?: number
  /** date of start of week */
  date?: string
  /** flag for if week is tournament week */
  is_tournament?: boolean
  active_players?: UserWeek[]
  rankings?: {
    /** id of user */
    user?: string
    /** Player name */
    name?: string
    /** Total monies paid to player this season */
    total_paid?: decimal
    /** Total monies paid to player this season */
    total_points?: decimal
    /** total first place finishes this season */
    count_firsts?: number
    /** total second place finishes this season */
    count_seconds?: number
    /** total third place finishes this season */
    count_thirds?: number
  }[]
  games?: Game[]
  available_users?: HostUser[]
}

/**
 * Season Model
 * Season model
 */
export interface SeasonModel {
  /** Unique identifier for the Season */
  id?: number
  /** Unique identifier of the host */
  host_id?: number
  /**
   * Name of the season
   * @example "2023 Q2"
   */
  name?: string
  /**
   * Start date of the season
   * @format date
   */
  start_date?: string
  /**
   * End date of the season
   * @format date
   */
  end_date?: string
  /**
   * Date of the tournament
   * @format date
   */
  tournament_date?: string
  /** Unique identifier of the winner (nullable) */
  winner_id?: number
  /** Unique identifier for donk (nullable) */
  donk_id?: number
  /**
   * Creation timestamp of the season record
   * @format date-time
   */
  created_at?: string
  /**
   * Last update timestamp of the season record
   * @format date-time
   */
  updated_at?: string
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer'
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string' ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`
        )
        return formData
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input)
  }

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    }
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {})
        },
        signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
        body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body)
      }
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title OneTeam Poker
 * @version 1.0.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Login by email and password, returns access and refresh tokens.
     *
     * @tags Authentication
     * @name LoginAccount
     * @summary Logs in a account
     * @request POST:/api/auth/login
     */
    loginAccount: (
      data: {
        /** Account Login Object */
        data: LoginAccount
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** Authorization Structure */
          authorization?: AuthStruct
          data?: {
            /** User model */
            user?: User
          }
        },
        | GenericErrorModel
        | AccountVerifiedError
        | {
            /** List of form field errors */
            message?: FormItemError[]
          }
      >({
        path: `/api/auth/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Creates a new User and returns the user data
     *
     * @tags Users
     * @name CreateUser
     * @summary Create a new User
     * @request POST:/api/users
     * @secure
     */
    createUser: (
      data: {
        /** Request body to register a new user */
        data: CreateUserRequest
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** User model */
          user?: User
        },
        | GenericErrorModel
        | {
            /** List of form field errors */
            message?: FormItemError[]
          }
      >({
        path: `/api/users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Refreshes the authentication token using a refresh token, returns new access and refresh tokens.
     *
     * @tags Authentication
     * @name RefreshToken
     * @summary Refreshes the user's authentication token
     * @request POST:/api/auth/refresh
     */
    refreshToken: (params: RequestParams = {}) =>
      this.request<
        {
          authorization?: {
            /** @example "new_access_token_here" */
            access_token?: string
            /** @example "new_refresh_token_here" */
            refresh_token?: string
            /** @example "bearer" */
            token_type?: string
            /** @example 3600 */
            expires_in?: number
          }
          data?: {
            /** User model */
            user?: User
          }
        },
        {
          /** @example "Unauthorized" */
          error?: string
        }
      >({
        path: `/api/auth/refresh`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * @description Returns the profile for the user with the corresponding id
     *
     * @tags Users
     * @name GetUserProfile
     * @summary Get a User's profiles
     * @request GET:/api/users/{id}/profile
     * @secure
     */
    getUserProfile: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** JWT token for authentication */
          token?: string
          /** User model */
          data?: User
        },
        GenericErrorModel
      >({
        path: `/api/users/${id}/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Sends a password reset link to the given email if it exists in the system.
     *
     * @tags Authentication
     * @name RequestPasswordReset
     * @summary Request a password reset link
     * @request POST:/api/forgot-password
     */
    requestPasswordReset: (
      data: {
        /** Initial Request to reset account password */
        data: ForgotPasswordRequest
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example "Password Reset Email Sent" */
          message?: string
        },
        | {
            /** @example "Error" */
            error?: string
          }
        | {
            /** List of form field errors */
            message?: FormItemError[]
          }
      >({
        path: `/api/forgot-password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Updates the account's password using a password reset token.
     *
     * @tags Authentication
     * @name ResetPassword
     * @summary Update the account's password
     * @request POST:/api/reset-password
     */
    resetPassword: (
      data: {
        /** Initial Request to reset account password */
        data: ResetPasswordRequest
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example "Password updated successfully" */
          message?: string
        },
        | {
            /** @example "Error" */
            error?: string
          }
        | {
            /** List of form field errors */
            message?: FormItemError[]
          }
      >({
        path: `/api/reset-password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a list of all Games with pagination
     *
     * @tags Games
     * @name GetGames
     * @summary Get all Games
     * @request GET:/api/games
     * @secure
     */
    getGames: (
      query?: {
        /**
         * Page number
         * @default 1
         */
        page?: number
        /**
         * Number of items per page
         * @default 25
         */
        perPage?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          data?: Game[]
          /** @example "124" */
          total?: number
          /** @example "25" */
          per_page?: number
          /** @example "1" */
          current_page?: number
          /** @example "5" */
          last_page?: number
        },
        GenericErrorModel
      >({
        path: `/api/games`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Creates a new Game and returns the game data
     *
     * @tags Games
     * @name CreateGame
     * @summary Create a new Game
     * @request POST:/api/games
     * @secure
     */
    createGame: (
      data: {
        /** Request body to store a Game model */
        data: StoreGameRequest
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a single Game
     *
     * @tags Games
     * @name GetGameById
     * @summary Get Game by ID
     * @request GET:/api/games/{id}
     * @secure
     */
    getGameById: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Deletes a game
     *
     * @tags Games
     * @name DeleteGame
     * @summary Delete an existing game
     * @request DELETE:/api/games/{id}
     * @secure
     */
    deleteGame: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** @example "deleted" */
          message?: string
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Updates an existing Game and returns the Game data. Requires authentication and the game ID.
     *
     * @tags Games
     * @name UpdateGame
     * @summary Update existing Game
     * @request PATCH:/api/games/{id}
     * @secure
     */
    updateGame: (
      id: number,
      data: {
        /** Request body to store a Game model */
        data: StoreGameRequest
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Attaches a player to a specific game by their IDs
     *
     * @tags Games
     * @name AttachPlayerToGame
     * @summary Attach a player to a Game
     * @request POST:/api/games/{id}/players/{playerId}
     * @secure
     */
    attachPlayerToGame: (id: number, playerId: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}/players/${playerId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Removes a player from a specific game by their IDs
     *
     * @tags Games
     * @name RemovePlayerFromGame
     * @summary Remove a player from a Game
     * @request DELETE:/api/games/{id}/players/{playerId}
     * @secure
     */
    removePlayerFromGame: (id: number, playerId: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}/players/${playerId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Attaches all players to a specific game
     *
     * @tags Games
     * @name AttachAllPlayersToGame
     * @summary Attach all players to a Game
     * @request POST:/api/games/{id}/players/all
     * @secure
     */
    attachAllPlayersToGame: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}/players/all`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Handles the seating arrangement for the specified game
     *
     * @tags Games
     * @name SeatGame
     * @summary Seat players for a Game
     * @request PUT:/api/games/{id}/seat
     * @secure
     */
    seatGame: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}/seat`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Marks the game as complete
     *
     * @tags Games
     * @name CompleteGame
     * @summary Mark Game as complete
     * @request PUT:/api/games/{id}/complete
     * @secure
     */
    completeGame: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}/complete`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Marks the game as complete
     *
     * @tags Games
     * @name CalculateGamePoints
     * @summary Calculate points for a completed Game
     * @request PUT:/api/games/{id}/points
     * @secure
     */
    calculateGamePoints: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}/points`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Set the dealer for the Game
     *
     * @tags Games
     * @name SetGameDealer
     * @summary Set the dealer and starting positions of each player in the Game
     * @request PUT:/api/games/{id}/dealer
     * @secure
     */
    setGameDealer: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}/dealer`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Mark a player out of the game
     *
     * @tags Games
     * @name MarkPlayerOut
     * @summary Mark a player out of the game
     * @request PUT:/api/games/{id}/{playerId}/out
     * @secure
     */
    markPlayerOut: (id: number, playerId: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}/${playerId}/out`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Mark a player in of the game
     *
     * @tags Games
     * @name MarkPlayerIn
     * @summary Add a player back into the game
     * @request PUT:/api/games/{id}/{playerId}/in
     * @secure
     */
    markPlayerIn: (id: number, playerId: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Game model */
          data?: Game
        },
        GenericErrorModel
      >({
        path: `/api/games/${id}/${playerId}/in`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a list of all Hosts
     *
     * @tags Hosts
     * @name GetHosts
     * @summary Get all Hosts
     * @request GET:/api/hosts
     * @secure
     */
    getHosts: (
      query?: {
        /**
         * Page number
         * @default 1
         */
        page?: number
        /**
         * Number of items per page
         * @default 25
         */
        perPage?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          data?: Host[]
          /** @example "124" */
          total?: number
          /** @example "25" */
          per_page?: number
          /** @example "1" */
          current_page?: number
          /** @example "5" */
          last_page?: number
        },
        GenericErrorModel
      >({
        path: `/api/hosts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Creates a new Host and returns the Host data
     *
     * @tags Hosts
     * @name CreateHost
     * @summary Create a new Host
     * @request POST:/api/hosts
     * @secure
     */
    createHost: (
      data: {
        /** Request body to store a host model */
        data: StoreHostRequest
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** Host model */
          host?: Host
        },
        GenericErrorModel
      >({
        path: `/api/hosts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a single Host
     *
     * @tags Hosts
     * @name GetHostById
     * @summary Get Host by ID
     * @request GET:/api/hosts/{id}
     * @secure
     */
    getHostById: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Host model */
          data?: Host
        },
        GenericErrorModel
      >({
        path: `/api/hosts/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Deletes a Host
     *
     * @tags Hosts
     * @name DeleteHost
     * @summary Delete an existing Host
     * @request DELETE:/api/hosts/{id}
     * @secure
     */
    deleteHost: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** @example "deleted" */
          message?: string
        },
        GenericErrorModel
      >({
        path: `/api/hosts/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Attaches a player to a specific Host by their IDs
     *
     * @tags Hosts
     * @name AttachUserToHost
     * @summary Attach a user to a Host
     * @request POST:/api/hosts/{id}/players/{userId}
     * @secure
     */
    attachUserToHost: (id: number, userId: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Host model */
          data?: Host
        },
        GenericErrorModel
      >({
        path: `/api/hosts/${id}/players/${userId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Removes a user from a Host by their IDs
     *
     * @tags Hosts
     * @name RemoveUserFromHost
     * @summary Remove a user from a Host
     * @request DELETE:/api/hosts/{id}/players/{userId}
     * @secure
     */
    removeUserFromHost: (id: number, userId: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Host model */
          data?: Host
        },
        GenericErrorModel
      >({
        path: `/api/hosts/${id}/players/${userId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Set the active season of a host using season id
     *
     * @tags Hosts
     * @name ActiveSeason
     * @summary Set the active season of a host
     * @request POST:/api/hosts/{id}/activeSeason/{seasonId}
     * @secure
     */
    activeSeason: (id: number, seasonId: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Host model */
          data?: Host
        },
        GenericErrorModel
      >({
        path: `/api/hosts/${id}/activeSeason/${seasonId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a list of all Seasons
     *
     * @tags Seasons
     * @name GetSeasons
     * @summary Get all Seasons
     * @request GET:/api/seasons
     * @secure
     */
    getSeasons: (
      query?: {
        /**
         * Page number
         * @default 1
         */
        page?: number
        /**
         * Number of items per page
         * @default 25
         */
        perPage?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          data?: Season[]
          /** @example "124" */
          total?: number
          /** @example "25" */
          per_page?: number
          /** @example "1" */
          current_page?: number
          /** @example "5" */
          last_page?: number
        },
        GenericErrorModel
      >({
        path: `/api/seasons`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Creates a new Season and returns the Season data
     *
     * @tags Seasons
     * @name CreateSeason
     * @summary Create a new Season
     * @request POST:/api/seasons
     * @secure
     */
    createSeason: (
      data: {
        /** Request body to store a Season model */
        data: StoreSeasonRequest
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** Season model */
          data?: Season
        },
        GenericErrorModel
      >({
        path: `/api/seasons`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a single Season based off the id provided
     *
     * @tags Seasons
     * @name GetSeason
     * @summary Get a specific Season using its id
     * @request GET:/api/seasons/{id}
     * @secure
     */
    getSeason: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Season model */
          data?: Season
        },
        GenericErrorModel
      >({
        path: `/api/seasons/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Deletes a season and returns no content
     *
     * @tags Seasons
     * @name DeleteSeason
     * @summary Delete existing season
     * @request DELETE:/api/seasons/{id}
     * @secure
     */
    deleteSeason: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** @example "deleted" */
          message?: string
        },
        GenericErrorModel
      >({
        path: `/api/seasons/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Updates an existing Season and returns the Season data. Requires authentication and the season ID.
     *
     * @tags Seasons
     * @name UpdateSeason
     * @summary Update existing Season
     * @request PATCH:/api/seasons/{id}
     * @secure
     */
    updateSeason: (
      id: number,
      data: {
        /** Request body to store a Season model */
        data: StoreSeasonRequest
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** Season model */
          data?: Season
        },
        GenericErrorModel
      >({
        path: `/api/seasons/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Set the active week of a season using week id
     *
     * @tags Seasons
     * @name ActiveWeek
     * @summary Set the active week of a season
     * @request POST:/api/seasons/{id}/activeWeek/{weekId}
     * @secure
     */
    activeWeek: (id: number, weekId: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Season model */
          data?: Season
        },
        GenericErrorModel
      >({
        path: `/api/seasons/${id}/activeWeek/${weekId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns the name of the winner
     *
     * @tags Seasons
     * @name GetSeasonWinner
     * @summary Get the Season winner
     * @request POST:/api/seasons/{id}/winner
     * @secure
     */
    getSeasonWinner: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Season model */
          data?: Season
        },
        GenericErrorModel
      >({
        path: `/api/seasons/${id}/winner`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a list of all Weeks
     *
     * @tags Weeks
     * @name GetWeeks
     * @summary Get all Weeks
     * @request GET:/api/weeks
     * @secure
     */
    getWeeks: (
      query?: {
        /**
         * Page number
         * @default 1
         */
        page?: number
        /**
         * Number of items per page
         * @default 25
         */
        perPage?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          data?: Week[]
          /** @example "124" */
          total?: number
          /** @example "25" */
          per_page?: number
          /** @example "1" */
          current_page?: number
          /** @example "5" */
          last_page?: number
        },
        GenericErrorModel
      >({
        path: `/api/weeks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Creates a new Week and returns the Week data
     *
     * @tags Weeks
     * @name CreateWeek
     * @summary Create a new Week
     * @request POST:/api/weeks
     * @secure
     */
    createWeek: (
      data: {
        /** Request body to store a Week model */
        data: StoreWeekRequest
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** Week model */
          week?: Week
        },
        GenericErrorModel
      >({
        path: `/api/weeks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a Week
     *
     * @tags Weeks
     * @name GetWeek
     * @summary Get Week
     * @request GET:/api/weeks/{id}
     * @secure
     */
    getWeek: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Week model */
          data?: Week
        },
        GenericErrorModel
      >({
        path: `/api/weeks/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Deletes a week and returns no content
     *
     * @tags Weeks
     * @name DeleteWeek
     * @summary Delete existing week
     * @request DELETE:/api/weeks/{id}
     * @secure
     */
    deleteWeek: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** @example "deleted" */
          message?: string
        },
        GenericErrorModel
      >({
        path: `/api/weeks/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Updates an existing Week and returns the Week data. Requires authentication and the week ID.
     *
     * @tags Weeks
     * @name UpdateWeek
     * @summary Update existing Week
     * @request PATCH:/api/weeks/{id}
     * @secure
     */
    updateWeek: (
      id: number,
      data: {
        /** Request body to store a Week model */
        data: StoreWeekRequest
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** Week model */
          data?: Week
        },
        GenericErrorModel
      >({
        path: `/api/weeks/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Attaches a player to the week
     *
     * @tags Weeks
     * @name AttachWeeklyPlayer
     * @summary Attach Player to Week
     * @request POST:/api/weeks/{id}/attach/{playerId}
     * @secure
     */
    attachWeeklyPlayer: (id: number, playerId: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Week model */
          data?: Week
        },
        GenericErrorModel
      >({
        path: `/api/weeks/${id}/attach/${playerId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Attaches a list of players to the week
     *
     * @tags Weeks
     * @name AttachWeeklyPlayers
     * @summary Attach Players to Week
     * @request POST:/api/weeks/{id}/attach/players
     * @secure
     */
    attachWeeklyPlayers: (
      id: number,
      data: {
        /** List of Player IDs to attach */
        playerIds?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** Week model */
          data?: Week
        },
        GenericErrorModel
      >({
        path: `/api/weeks/${id}/attach/players`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Sets a list of players to the week
     *
     * @tags Weeks
     * @name SetWeeklyPlayers
     * @summary Set Players to Week
     * @request POST:/api/weeks/{id}/set/players
     * @secure
     */
    setWeeklyPlayers: (
      id: number,
      data: {
        /** List of Player IDs to set */
        playerIds?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** Week model */
          data?: Week
        },
        GenericErrorModel
      >({
        path: `/api/weeks/${id}/set/players`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Removes a player from the Week
     *
     * @tags Weeks
     * @name RemovePlayer
     * @summary Remove a Player from a Week
     * @request DELETE:/api/weeks/{id}/remove/{playerId}
     * @secure
     */
    removePlayer: (id: number, playerId: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Week model */
          data?: Week
        },
        GenericErrorModel
      >({
        path: `/api/weeks/${id}/remove/${playerId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Removes players from the Week
     *
     * @tags Weeks
     * @name RemovePlayers
     * @summary Remove players from a Week
     * @request DELETE:/api/weeks/{id}/remove/players
     * @secure
     */
    removePlayers: (
      id: number,
      data: {
        /** List of Player IDs to attach */
        playerIds?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** Week model */
          data?: Week
        },
        GenericErrorModel
      >({
        path: `/api/weeks/${id}/remove/players`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Attaches all players to the week
     *
     * @tags Weeks
     * @name AttachAllPlayers
     * @summary Attach all Players to the Week
     * @request POST:/api/weeks/{id}/attach/all
     * @secure
     */
    attachAllPlayers: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Week model */
          data?: Week
        },
        GenericErrorModel
      >({
        path: `/api/weeks/${id}/attach/all`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Calculate the weekly points for each player
     *
     * @tags Weeks
     * @name CalculateWeekPoints
     * @summary Calculate player points
     * @request PUT:/api/weeks/{id}/calculate-points
     * @secure
     */
    calculateWeekPoints: (id: number, params: RequestParams = {}) =>
      this.request<
        {
          /** Week model */
          data?: Week
        },
        GenericErrorModel
      >({
        path: `/api/weeks/${id}/calculate-points`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params
      })
  }
}
